"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.OrdiNFTP2PKH = void 0;
/* eslint-disable @typescript-eslint/no-explicit-any */
/* eslint-disable @typescript-eslint/no-unused-vars */
/* eslint-disable @typescript-eslint/no-unused-vars */
const scrypt_ts_1 = require("scrypt-ts");
const ordinal_1 = require("./ordinal");
const ordinalNFT_1 = require("./ordinalNFT");
const P2PKHScriptLen = 50;
class OrdiNFTP2PKH extends ordinalNFT_1.OrdinalNFT {
    constructor(addr) {
        super();
        this.init(addr);
        this.addr = addr;
    }
    unlock(sig, pubkey) {
        // Check if the passed public key belongs to the specified address.
        (0, scrypt_ts_1.assert)((0, scrypt_ts_1.pubKey2Addr)(pubkey) == this.addr, 'public key hashes are not equal');
        // Check signature validity.
        (0, scrypt_ts_1.assert)(this.checkSig(sig, pubkey), 'signature check failed');
    }
    getNopScript() {
        const nop = this.getPrependNOPScript();
        if (nop) {
            return nop;
        }
        if (this.from) {
            const ls = scrypt_ts_1.bsv.Script.fromHex(this.utxo.script);
            if (ordinal_1.Ordinal.isOrdinalP2PKHV1(ls)) {
                return scrypt_ts_1.bsv.Script.fromHex(ls.toHex().slice(P2PKHScriptLen));
            }
            if (ordinal_1.Ordinal.isOrdinalP2PKHV2(ls)) {
                return scrypt_ts_1.bsv.Script.fromHex(ordinal_1.Ordinal.getInsciptionScript(this.utxo.script));
            }
        }
        return null;
    }
    get lockingScript() {
        const nop = this.getNopScript();
        if (nop) {
            return new scrypt_ts_1.bsv.Script('')
                .add(nop)
                .add(scrypt_ts_1.bsv.Opcode.OP_DUP)
                .add(scrypt_ts_1.bsv.Opcode.OP_HASH160)
                .add(scrypt_ts_1.bsv.Script.fromASM(this.addr))
                .add(scrypt_ts_1.bsv.Opcode.OP_EQUALVERIFY)
                .add(scrypt_ts_1.bsv.Opcode.OP_CHECKSIG);
        }
        return super.lockingScript;
    }
    static fromLockingScript(script) {
        const ls = scrypt_ts_1.bsv.Script.fromHex(script);
        const DelegateClazz = this.getDelegateClazz();
        if (!DelegateClazz) {
            throw new Error('no DelegateClazz found!');
        }
        let rawP2PKH = '';
        if (ordinal_1.Ordinal.isOrdinalP2PKHV1(ls)) {
            rawP2PKH = script.slice(0, P2PKHScriptLen);
        }
        else if (ordinal_1.Ordinal.isOrdinalP2PKHV2(ls)) {
            rawP2PKH = script.slice(Number(ordinal_1.Ordinal.sizeOfOrdinal(script)) * 2);
        }
        else if (ordinal_1.Ordinal.isP2PKH(script)) {
            rawP2PKH = script;
        }
        const delegateInstance = DelegateClazz.fromHex(rawP2PKH);
        // recreate instance
        const args = delegateInstance.ctorArgs().map((arg) => {
            return arg.value;
        });
        // we can't  get max, and lim from the bsv20 insciption script.
        const instance = new this((0, scrypt_ts_1.Addr)(args[0]));
        instance.setDelegateInstance(delegateInstance);
        return instance;
    }
    static fromUTXO(utxo) {
        if (utxo.satoshis !== 1) {
            throw new Error('invalid ordinal p2pkh utxo');
        }
        const ls = scrypt_ts_1.bsv.Script.fromHex(utxo.script);
        if (!ordinal_1.Ordinal.isOrdinalP2PKH(ls) && !ordinal_1.Ordinal.isP2PKH(utxo.script)) {
            throw new Error('invalid ordinal p2pkh utxo');
        }
        const instance = this.fromLockingScript(utxo.script);
        instance.from = utxo;
        return instance;
    }
}
exports.OrdiNFTP2PKH = OrdiNFTP2PKH;
__decorate([
    (0, scrypt_ts_1.prop)()
], OrdiNFTP2PKH.prototype, "addr", void 0);
__decorate([
    (0, scrypt_ts_1.method)()
], OrdiNFTP2PKH.prototype, "unlock", null);
const desc = {
    version: 9,
    compilerVersion: '1.19.0+commit.72eaeba',
    contract: 'OrdiNFTP2PKH',
    md5: '0c046dfb1f1a91cf72b9a852537bdfe1',
    structs: [],
    library: [],
    alias: [],
    abi: [
        {
            type: 'function',
            name: 'unlock',
            index: 0,
            params: [
                {
                    name: 'sig',
                    type: 'Sig',
                },
                {
                    name: 'pubkey',
                    type: 'PubKey',
                },
            ],
        },
        {
            type: 'constructor',
            params: [
                {
                    name: 'addr',
                    type: 'Ripemd160',
                },
            ],
        },
    ],
    stateProps: [],
    buildType: 'release',
    file: '',
    hex: '76a9<addr>88ac',
    sourceMapFile: '',
};
OrdiNFTP2PKH.loadArtifact(desc);
